import axios from "axios";
import { Component } from "react";
import XMLParser from "react-xml-parser";
import { convertLocalDateStrToDateMoment, finishExistingTenantNote, tenantId } from "./Common";
import { getLastPaymentDateTimeMoment, paymentRetryFailureAlert, SERVERS_TIME_DIFFERENCE } from "./paygateway";
import { logApiFail, logSSMRequest, logSSMResponse } from "./rollbar";
import { updateTransactionStatus, TRANSACTION_STATUS } from "./transactionStatus";
export class ProcessPaymentRetry extends Component {
  constructor(props) {
    super(props);
    this.retryCount = 0;
    this.timeoutId = null;
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      console.log("cleared timeout id");
      clearTimeout(this.timeoutId);
    }
  }

  handleProcessPaymentAPI = async (requestBody, successCb, failedCb, retryFailedCb, isExistingTenantFlow = false) => {
    const beforePaymentTimeMoment = convertLocalDateStrToDateMoment(
      new Date(Date.now() - SERVERS_TIME_DIFFERENCE).toLocaleString("en-US", {
        timeZone: "America/Cancun",
      })
    );

    // Get order_id from request body for status tracking
    const orderId = requestBody.order_id || sessionStorage.getItem('existing_tenant_order_id') || sessionStorage.getItem('new_tenant_order_id');

    // Update status to PROCESS_PAYMENT_V2_STARTED
    if (orderId) {
      await updateTransactionStatus(orderId, TRANSACTION_STATUS.PROCESS_PAYMENT_V2_STARTED, {
        step: 'process_payment_v2_started',
        retry_count: this.retryCount,
      });
    }

    logSSMRequest("/api/ssm/ProcessPayment_V2", requestBody);

    axios
      .post("/api/ssm/ProcessPayment_V2", JSON.stringify(requestBody), {
        headers: { "Content-Type": "application/json" },
      })
      .then(async (response) => {
        logSSMResponse("/api/ssm/ProcessPayment_V2", response.data, true);
        const data = new XMLParser().parseFromString(response.data);
        const result = data.getElementsByTagName("PaymentMessage")[0].value;
        if (result === "Successful") {
          // Update status to PROCESS_PAYMENT_V2_FINISHED
          if (orderId) {
            await updateTransactionStatus(orderId, TRANSACTION_STATUS.PROCESS_PAYMENT_V2_FINISHED, {
              step: 'process_payment_v2_success',
            });
          }
          finishExistingTenantNote(tenantId(), "Credit Card");
          await successCb();
        } else {
          // additional check if payment has been processed
          if (result.includes("Unable to process the payment, For this Order Id payment has been processed")) {
            // Still mark as finished since payment was processed
            if (orderId) {
              await updateTransactionStatus(orderId, TRANSACTION_STATUS.PROCESS_PAYMENT_V2_FINISHED, {
                step: 'process_payment_v2_already_processed',
              });
            }
            await successCb();
            return;
          }
          // Update status to FAILED
          if (orderId) {
            await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
              step: 'process_payment_v2_failed',
              error: result,
            });
          }
          failedCb(result);
        }
      })
      .catch(async (e) => {
        logSSMResponse("/api/ssm/ProcessPayment_V2", e.response?.data || e.message, false);
        if (e?.response?.data?.error.includes("Error: timeout")) {
          console.log("timeout");
          // timeout error
          const lastPaymentDateTimeMoment = await getLastPaymentDateTimeMoment(
            requestBody.location_code,
            requestBody.tenant_id
          );
          // lastPaymentDateTime is in America/Cancun time zone
          // convert to moment with America/Cancun timezone
          if (lastPaymentDateTimeMoment && lastPaymentDateTimeMoment.isAfter(beforePaymentTimeMoment)) {
            // no need for retry, already make last payment in case of time out
            console.log("payment already processed");
            // Mark as finished since payment was processed
            if (orderId) {
              await updateTransactionStatus(orderId, TRANSACTION_STATUS.PROCESS_PAYMENT_V2_FINISHED, {
                step: 'process_payment_v2_timeout_but_processed',
              });
            }
            await successCb();
            return;
          }
        }
        if (this.retryCount < 3) {
          this.timeoutId = setTimeout(() => {
            this.handleProcessPaymentAPI(requestBody, successCb, failedCb, retryFailedCb, isExistingTenantFlow);
            this.retryCount += 1;
          }, 3000);
        } else {
          // Update status to FAILED after max retries
          if (orderId) {
            await updateTransactionStatus(orderId, TRANSACTION_STATUS.FAILED, {
              step: 'process_payment_v2_max_retries_exceeded',
              error: e.response?.data || e.message,
              retry_count: this.retryCount,
            });
          }
          logApiFail("ProcessPayment_V2", requestBody, e);
          if (!isExistingTenantFlow) {
            paymentRetryFailureAlert();
          }
          if (typeof retryFailedCb === "function") {
            retryFailedCb();
          }
        }
      });
  };
}

export default ProcessPaymentRetry;
